import { Component, Input, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { DhukanDataService } from 'src/app/services/dhukan/dhukan-data.service';
import { LoginDataService } from 'src/app/services/dhukan/login-data.service';
import { ConfirmationDialogService } from '../confirmation-dialog/confirmation-dialog.service';

import html from 'src/app/components/templatesettings/receipt'
import { DomSanitizer } from '@angular/platform-browser';

@Component({
  selector: 'app-templatesettings',
  templateUrl: './templatesettings.component.html',
  styleUrls: ['./templatesettings.component.css']
})
export class TemplatesettingsComponent implements OnInit {


  isadd: boolean = false;
  isedit: boolean = false;
  isdelete: boolean = false;
  isview: boolean = false;
  isprint: boolean = false;
  isexport: boolean = false;
  isfilter: boolean = false;
  moduleBO: any = {};
  settingsgroupColl: any = [];
  settingsColl: any = [];
  pricetypeColl: any = [];
  grpresults: any = [];
  istds: boolean = false;
  ispf: boolean = false;
  isept: boolean = false;

  shtkeys = ["1", "2", "3", "4", "5", "6", "7", "8", "9", "0", "+", "-", "*", "/", "a", "b", "c", "d", "e", "f", "g", "h", "i", "j", "k", "l", "m", "n", "o", "p", "q", "r", "s", "t.u", "v", "w", "x", "y", "z", "F1", "F2", "F3", "F4", "F5", "F6", "F7", "F8", "F9", "F10", "F11", "F12", "Escape", "Tab", "Shift", "Control", "Escape"]

  isloading: boolean = false;
  isprivilage: boolean = false;
  showProgress: boolean = false;
  saveloading: boolean;

  settingsgroupname = "";
  defaultaccountgroupname = "";

  formname: string = "Settings";

  @Input() defaultaccountColl: any = [];

  @Input() taxtypeColl: any = [];

  editformtype: string = "RECEIPT";

  receipttemplate: any = null;
  kottemplate: any = null;


  receiptlogo: any = null;
  receiptheader: any = null;

  foo:any;

  public model = {
    name: 'Hardik',
    description: '<p>This is a sample form using CKEditor 4.</p>'
  };


  constructor(private appService: DhukanDataService, public loginService: LoginDataService, public router: Router, private route: ActivatedRoute,
    private confirmationDialogService: ConfirmationDialogService, private toastr: ToastrService,private sanitized: DomSanitizer) {
    this.fnServiceChanges();
  }



  //User Check
  fnServiceChanges() {
    this.loginService.serviceloginChange.subscribe((value) => {
      if (this.loginService.fnCheckUser()) {
        this.fnCheckPrivilage();
        if (this.isview) {
          this.isloading = true;
          this.fnOnInitForm();
        }
        else {
          this.fnUserFailedForm();
        }
      }
      else {
        this.fnUserFailedForm();
      }
    });
  }

  ngOnInit() {
    try {



      if (this.loginService.fnCheckUser()) {
        this.fnCheckPrivilage();
        if (this.isview) {
          this.isloading = true;
          this.fnOnInitForm();
        }
        else {
          this.fnUserFailedForm();
        }
      }
      else {
        this.loginService.fnGetUserRoleList();
      }

    } catch (ex) {
      this.fnShowErrorMsg(ex);
    }
  }

  fnOnInitForm() {
    this.fngetPricetype()
    this.fngetSettings();
  }


  fnCheckPrivilage() {

    this.isadd = this.loginService.fnCheckUserRoleAction(this.formname, 'CREATE');
    this.isedit = this.loginService.fnCheckUserRoleAction(this.formname, 'ALTER');
    this.isdelete = this.loginService.fnCheckUserRoleAction(this.formname, 'DELETE');
    this.isview = this.loginService.fnCheckUserRoleAction(this.formname, 'VIEW');
    this.isprint = this.loginService.fnCheckUserRoleAction(this.formname, 'PRINT');
    this.isexport = this.loginService.fnCheckUserRoleAction(this.formname, 'EXPORT');


  }

  fnUserFailedForm() {
    this.isprivilage = true;
  }


  fngetPricetype() {
    var data = {
      'pricetypeid': 0,
      'companyid': this.loginService.fnGetCompanyId(),
    }
    this.appService.getPricetype(data)
      .subscribe(
        (res) => {
          if (res.json().status === 200) {
            this.pricetypeColl = res.json().result;
          }
        },
        (err) => {
          this.toastr.error('Error', err);
        })
  }

  //Get
  fngetSettings() {
    var data = {
      'settingsid': 0,
      'companyid': this.loginService.fnGetCompanyId(),
    }
    this.appService.getSettingsCompany(data)
      .subscribe(
        (res) => {

          if (res.json().status === 200) {
            this.settingsgroupColl = res.json().result[0];

            this.settingsColl = res.json().result[1];

             

            for (let abo of this.settingsColl) {

              if (abo.settingsname === 'RECIEPT_CUSTOM_TEMPLATE') {
                console.log( abo )
                this.receipttemplate = abo.settingsvalue
              }
              if (abo.settingsname === 'KOT_CUSTOM_TEMPLATE') {
                this.kottemplate = abo.settingsvalue
              }
            }
          
          

            if (this.receipttemplate === null || this.receipttemplate === '') {
              //this.receipttemplate = document.getElementById("gvreceiptcopy").innerHTML;

              this.receipttemplate=html;

              this.fnEditReceiptHTML()
            }

            //this.fnTabClickModule('RECEIPT')


            // var groups = new Set(this.settingsColl.map(item => item.sectionname))

            // this.grpresults = [];
            // groups.forEach(g =>
            //   this.grpresults.push({
            //     name: g,
            //     values: this.settingsColl.filter(i => i.group === g)
            //   }
            // ))


          } else {
            // this.loginService.fnAPIError(res.json())
          }
        },
        (err) => {
          this.toastr.error('Error', err);
        })
  }
  fnSaveBtnClick() {
    if (this.saveloading) {
      return
    }
    this.saveloading = true
    for (let row of this.settingsColl) {
      //console.log(row)
      if (row.fieldtype === 'CHECKBOX' && row.settingsvalue === true) {
        row.settingsvalue = 1;
      }
      else if (row.fieldtype === 'CHECKBOX' && row.settingsvalue !== true) {
        row.settingsvalue = 0;
      }
      row.companyid = this.loginService.fnGetCompanyId();
      row.modifiedby = this.loginService.fnGetModUserId();
      
      if(row.settingsname === 'RECIEPT_CUSTOM_TEMPLATE'){
         row.settingsvalue=this.receipttemplate
        this.fnSetSettings(row);
      }
      if(row.settingsname === 'KOT_CUSTOM_TEMPLATE'){
        row.settingsvalue=this.kottemplate
        this.fnSetSettings(row);
      }
      
      this.fnCloseForm();
    }
    console.log(this.settingsColl)
  }

  fnSetSettings(data) {
 
    this.appService.fnsetSettingsCompany(data).subscribe(
      (res) => {
        this.saveloading = false
        console.log(res.json())
        alert()
        if (res.json().status === 200) {
          if (res.json().result != "") {

          }
        }
        else {
          //this.loginService.fnAPIError(res.json())
        }
      },
      (err) => {
        this.saveloading = false
        this.toastr.error('Error', err);
      });

  }

fnEditReceiptHTML(){
  this.foo = this.sanitized.bypassSecurityTrustHtml( this.receipttemplate);

  console.log(this.receipttemplate)
}

  fnCloseForm() {
    try {
      this.router.navigate(['/Configration']);
    } catch (ex) {
      this.fnShowErrorMsg(ex);
    }
  }

  fnTabClickModule(item) {

    this.editformtype = item.settingstype;




  }


  fnInsertActivityLog(action, refno, desc) {
    try {
      var data = {
        logtype: action,
        logat: this.formname,
        refnum: refno,
        logdescr: desc, companyid: 0,
        logby: this.loginService.fnGetModUserId(),
      }


      this.appService.fnInsertActivity(data).subscribe(
        (res) => {
        },
        (err) => {

        });

    } catch {

    }
  }
  private fnShowProgress() {
    this.showProgress = true;
  }
  private fnHideProgress() {
    this.showProgress = false;
  }

  private fnShowErrorMsg(ex) {
    this.toastr.warning('Internal Error', ex);
  }



}
